import { AxiosError, AxiosResponse } from 'axios';
import {
  QueryFunctionContext,
  useQuery,
  UseQueryResult,
  UseQueryOptions,
  QueryKey,
} from 'react-query';
import { useToastContext } from '@/contexts/toastContext';
import { onAPIError } from '@/utils/global';

const useApiFetch = <ResponseType, ParamsType = any>(
  id: QueryKey,
  fn: (arg0?: QueryFunctionContext<QueryKey, ParamsType>) => Promise<AxiosResponse<ResponseType>>,
  options?: UseQueryOptions<ResponseType, AxiosError>
): UseQueryResult<ResponseType, AxiosError> => {
  const toast = useToastContext();
  return useQuery<ResponseType, AxiosError>(
    id,
    async (args) => {
      const { data } = await fn(args);
      return data;
    },
    {
      ...options,
      onError: (error) => onAPIError(error, options, toast),
    }
  );
};

export default useApiFetch;
